import * as React from "react"

import Link from "../Link"

interface Props {
    attributes: Record<string, string>
    label: string
}

// PARAMETERS => OPENS THE CONFIGURATION PAGE WITH THE PARAMETERS
export const ParametersInternalLink = ({
    attributes,
    label,
}: Props): JSX.Element => {
    const href = "config/parameters"

    return <Link attributes={attributes} label={label} href={href} />
}

export default ParametersInternalLink
